<script setup lang="ts">
import { ref } from 'vue'

import UiInput from '@/components/shared/UiInput.vue'
import UiButton from '@/components/shared/UiButton.vue'

import BetIcon from '@/assets/icons/bet.svg?component'
import OkIcon from '@/assets/icons/ok.svg?component'
import CloseIcon from '@/assets/X.svg'

const props = defineProps<{
  stack: number
  isBot?: boolean
  openOnly?: boolean
  index: number | string
  disabled?: boolean
}>()

const emit = defineEmits<{
  submit: [value: number]
  cancel: []
  removeBot: []
}>()

const localStack = ref(props.stack)
const isEdit = ref(false)

function submit() {
  isEdit.value = false
  emit('submit', localStack.value)
}

function cancel() {
  isEdit.value = false
  emit('cancel')
}
</script>

<template>
  <div class="flex w-full gap-[6px]" :class="{ 'flex-wrap': isEdit }">
    <ui-button
      v-if="!isEdit && !openOnly"
      variant="secondary"
      class="w-full rounded-full!"
      @click="isEdit = true"
      >{{ $t('Compete.button.Edit') }}</ui-button
    >
    <form v-else class="flex w-full gap-[6px]" @submit.prevent="submit()">
      <ui-input
        :modelValue="localStack"
        :placeholder="$t('Compete.placeholder.StackAmountPlaceholder')"
        @update:model-value="localStack = Number($event)"
        wrapper-class="players-menu__input"
        inner-class="player-menu__input-inner"
        inputmode="numeric"
        :mask="{
          mask: '9 99#',
          reversed: true,
          tokens: { '9': { pattern: /[0-9]/, repeated: true } }
        }"
      >
        <template #icon><bet-icon /></template>
      </ui-input>
      <ui-button
        class="h-[44px] w-[44px] items-center justify-center rounded-full! p-0!"
        variant="secondary"
        type="button"
        @click="cancel"
      >
        <close-icon class="h-5 w-5" />
      </ui-button>
      <ui-button
        class="h-[44px] w-[44px] items-center justify-center rounded-full! p-0!"
        variant="primary"
        type="submit"
      >
        <ok-icon class="h-4 w-4" />
      </ui-button>
    </form>

    <ui-button
      v-if="isBot"
      variant="secondary"
      class="w-full !rounded-full"
      :disabled="disabled"
      :id="`remove-bot-${index}-button`"
      @click="emit('removeBot')"
    >
      {{ $t('Compete.button.RemoveBot') }}
    </ui-button>
  </div>
</template>

<style lang="scss" scoped>
.players-menu-card {
  display: flex;
  padding: 12px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;

  border-radius: 12px;
  border: 1px solid #2c2d3e;
  background-color: #1f212e;
  color: #86899e;

  &__info {
    display: flex;
    gap: 12px;
    align-self: stretch;
  }

  &__details {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__avatar {
    width: 44px;
    height: 44px;
  }

  &__name {
    color: #fff;
    font-size: 14px;
    font-weight: 500;
  }

  &__id {
    display: inline-flex;
    padding: 2px 6px;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #86899e;

    border-radius: 6px;
    background: #2c2d3e;
  }

  &__extra {
    font-size: 12px;
    display: inline-flex;
    align-items: center;
  }
}
</style>
